import request from "@/utils/request";
import { buildApiV1Path } from "@/utils/apiPath";

export interface ConfirmedDataExportParams {
  studyId: string;
  siteId?: string;
}

export interface DataExportStatus {
  enabled: boolean;
  source?: string;
  scope?: string;
  reason?: string | null;
}

export interface DataExportStatusResponse {
  success: boolean;
  data: DataExportStatus;
}

export function getDataExportStatus(
  params: ConfirmedDataExportParams,
): Promise<DataExportStatusResponse> {
  return request.get(buildApiV1Path("admin", "data-export", "status"), {
    params,
  });
}

export function exportConfirmedData(
  params: ConfirmedDataExportParams,
): Promise<Blob> {
  return request.get(buildApiV1Path("admin", "data-export", "confirmed.xlsx"), {
    params,
    responseType: "blob",
    timeout: 120000,
  });
}
